import React from "react";

export default function Footer() {
  return (
    <footer className="text-center text-muted py-4 mt-0 pt-0">
      <p className="mb-0">
        &copy; {new Date().getFullYear()} Jaakko Lahtinen
      </p>
    </footer>
  );
}
